import { ResourceArticleCard } from "@vega-core/components/Cards/ResourceArticleCard/ResourceArticleCard";
import { m } from "@vega-core/paraglide/messages";

import { type Article, PreviewType } from "../types/article";

type Props = {
  articles: Article[];
  onArticleClick: (slug: string) => void;
};

export const ResourcesArticles = ({ articles, onArticleClick }: Props) => (
  <div className="grid auto-rows-fr gap-6 sm:grid-cols-2 xl:grid-cols-4">
    {articles.map((article) => (
      <ResourceArticleCard
        actionLabel={m.localcms_resources_read_article()}
        ariaLabel={m.localcms_resources_open_article({
          title: article.title,
        })}
        description={article.description}
        imageUrl={
          article.previewType === PreviewType.Image
            ? article.previewUrl
            : undefined
        }
        key={article.id}
        onClick={() => onArticleClick(article.slug)}
        readTime={m.localcms_read_time_minutes({
          minutes: article.readingTime,
        })}
        title={article.title}
        videoUrl={
          article.previewType === PreviewType.Video
            ? article.previewUrl
            : undefined
        }
      />
    ))}
  </div>
);
